export * from './ellipsis-text';